import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { CSSResultGroup, LitElement, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './carousel-item.style.js'

@customElement('csc-carousel-item')
export class CSCCarouselItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  override render() {
    return html`
      <slot></slot>
    `
  }
}

declare global {
    interface HTMLElementTagNameMap {
      'csc-carousel-item': CSCCarouselItem,
    }
  }
  
